import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { FormBuilderComponent } from '../../../../../../form-builder/lib/form-builder/form-builder.component';
import { RequestFormGroup } from '../../../../../../form-builder/interface/request-form-builder.model';
import { RequestComponentService } from '../../../../employee-flow/request/services/request-component/request-component.service';
import { LoaderComponent } from '../../../../../../ui-components/lib/loader/loader.component';
import { CustomWorkflowService } from '../custom-workflow.service';

@Component({
  selector: 'lib-custom-workflow-preview',
  imports: [FormBuilderComponent, LoaderComponent, TranslocoPipe],
  templateUrl: './custom-workflow-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomWorkflowPreviewComponent implements OnInit {
  private readonly service = inject(CustomWorkflowService);
  private readonly requestComponentService = inject(RequestComponentService);

  workflowId = input.required<number>();
  groups = signal<RequestFormGroup[] | null>(null);
  form = new FormGroup({});

  ngOnInit() {
    this.service.preview(this.workflowId()).subscribe(res => {
      this.form = this.requestComponentService.buildRequestForm(res.data.sections);
      this.groups.set(res.data.sections);
    });
  }
}
